module.exports = __webpack_public_path__ + "static/media/task_detail_division.78f47047.svg";